// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2qXhP","productName":"Table_productName__1U_2Q"};